import { gltfLoaderComponentType } from 'src/sdk-components';
import { CONTROLLER_CONSTANTS } from 'src/service/scene/scene-nodes/SceneController/constants';
import { ComponentInteractionType } from 'src/sdk-components/SceneComponent';
import { LoadingState } from 'src/service/scene/types';

export class Button {
  public context: any;

  public config: any;

  public canBeInteracted = false;

  public active = false;

  public component: any;

  private constructor(component, context, config, events) {
    this.component = component;
    this.context = context;
    this.config = config;

    component.onEvent = async (type: string) => {
      if (type === ComponentInteractionType.CLICK) {
        if (events.onClick) events.onClick();
      }
    };

    component.outputs.onPropertyChanged('loadingState', async (state: any) => {
      if (state === LoadingState.Loaded) {
        if (events.onLoaded) events.onLoaded();
      }
    });
  }

  static async create(context, modelNode, config: any = {}, events = {}) {
    const component = await modelNode.addComponent(gltfLoaderComponentType, {
      url: config.url ? config.url : CONTROLLER_CONSTANTS.URL_BUTTON,
      animationTriggerEnabled: true,
      animationEnabled: true,
      animationLoop: false
    });

    return new Button(component, context, config, events);
  }
}
